import React, {useEffect, useRef} from 'react';
import {View, Animated, Easing} from 'react-native';
import {Text} from '../../../../../shared/components/text';
import {useStyles} from '../../../../../shared/hooks/styles';

export function TypingIndicator() {
  const dot1 = useRef(new Animated.Value(0)).current;
  const dot2 = useRef(new Animated.Value(0)).current;
  const dot3 = useRef(new Animated.Value(0)).current;

  const styles = useStyles(({theme}) => ({
    container: {
      borderRadius: 16,
      paddingRight: 14,
      paddingLeft: 34,
      flexDirection: 'row',
      alignItems: 'flex-end',
    },
    dot: {
      width: 6,
      height: 6,
      borderRadius: 3,
      backgroundColor: theme.color.labelText,
      marginHorizontal: 2,
    },
    chatbotName: {
      marginRight: 6,
      fontSize: 12,
      lineHeight: 12,
      fontWeight: '400',
      color: theme.color.primaryBlackColor,
    },
  }));

  const dotStyle = (anim: Animated.Value) => ({
    opacity: anim,
    transform: [
      {
        translateY: anim.interpolate({
          inputRange: [0, 1],
          outputRange: [0, -2],
        }),
      },
    ],
  });

  const animate = (dot: Animated.Value, delay: number) => {
    return Animated.loop(
      Animated.sequence([
        Animated.timing(dot, {
          toValue: 1,
          duration: 400,
          delay,
          easing: Easing.inOut(Easing.ease),
          useNativeDriver: true,
        }),
        Animated.timing(dot, {
          toValue: 0,
          duration: 400,
          easing: Easing.inOut(Easing.ease),
          useNativeDriver: true,
        }),
      ]),
    );
  };

  useEffect(() => {
    const animation1 = animate(dot1, 0);
    const animation2 = animate(dot2, 200);
    const animation3 = animate(dot3, 400);

    animation1.start();
    animation2.start();
    animation3.start();

    return () => {
      animation1.stop();
      animation2.stop();
      animation3.stop();
    };
  }, []);

  return (
    <View style={styles.container}>
      <Text style={styles.chatbotName}>Уралочка Ассистент печатает</Text>
      <Animated.View style={[styles.dot, dotStyle(dot1)]} />
      <Animated.View style={[styles.dot, dotStyle(dot2)]} />
      <Animated.View style={[styles.dot, dotStyle(dot3)]} />
    </View>
  );
}
